import { isEmpty } from 'lodash';
import { MsgTemplate } from '../../schema/message/inferface';
import { getTextTemplate } from './get-text-template';

export const getUnknownTemplate = (text: string): MsgTemplate => {
  if (!isEmpty(text)) return getTextTemplate(text);
  return {
    unknown: {
      params: [],
      components: [
        { type: 'BODY', text: 'Content for this message is unavailable' },
      ],
    },
  };
};

export const getUnknownTemplateV2 = (text: string): MsgTemplate => {
  if (!isEmpty(text)) return getTextTemplate(text);
  return {
    unknown: {
      params: [],
      components: [
        {
          type: 'BODY',
          text: `This message can't be displayed here. Please open the ZoTok web to view the message.`,
        },
      ],
    },
  };
};
